<template>
  <div class="register-verification">
    <p class="register-sub-title">{{ $t('enterSendCode') }}</p>

    <InputCode
      class="opt-code"
      :password="form.authCode"
      :pass-number="true"
      :is-error="!!codeInputError"
      @click="handleInput"
    />

    <LinkButton
      :decoration="false"
      class="re-send-button"
      :disabled="countdown !== 0 || resendDisabled"
      @click="handleResendCode"
    >
      {{ computedSendBtnText }}
    </LinkButton>

    <div class="error-view">{{ codeInputError }}</div>

    <md-number-keyboard
      v-model="showBoard"
      is-hide-confirm
      type="simple"
      hide-dot
      @enter="handleEnterValue"
      @delete="handleDeleteValue"
    />
  </div>
</template>

<script>
import InputCode from '@/components/InputCode'
import LinkButton from '@/components/LinkButton'
import { NumberKeyboard, Toast } from 'mand-mobile'
import { updateOtp } from '@/api/otp'

function formatTimer (time) {
  if (`${time}`.length < 2) {
    return `0${time}`
  }

  return time
}

function secondToDate (result) {
  const m = formatTimer(Math.floor((result / 60 % 60)))
  const s = formatTimer(Math.floor((result % 60)))
  return `${m}:${s}`
}

const COUNTDOWN = 60

export default {
  name: 'OtpInput',

  components: {
    InputCode,
    LinkButton,
    [NumberKeyboard.name]: NumberKeyboard
  },

  data () {
    this.countdownTimer = null
    return {
      showBoard: true,
      resendDisabled: true,
      countdown: COUNTDOWN,
      form: {
        authCode: ''
      },
      codeInputError: ''
    }
  },

  computed: {
    computedCountdown () {
      return secondToDate(this.countdown)
    },

    computedSendBtnText () {
      return this.countdown === 0 ? this.$t('resend_code') : this.$t('resendCode', { s: this.computedCountdown })
    }
  },

  destroyed () {
    clearInterval(this.countdownTimer)
  },

  created () {
    this.createCountdown()
  },

  methods: {
    async createCountdown () {
      try {
        this.resendDisabled = true
        await updateOtp()
      } finally {
        this.resendDisabled = false
      }
      this.countdown = COUNTDOWN

      this.countdownTimer = setInterval(() => {
        if (this.countdown === 0) {
          clearInterval(this.countdownTimer)
          return
        }

        this.countdown--
      }, 1000)
    },
    handleInput () {
      this.showBoard = true
      this.codeInputError = ''
    },
    handleEnterValue (value) {
      this.codeInputError = ''
      if (this.form.authCode.length >= 6) return
      this.form.authCode = `${this.form.authCode}${value}`

      if (this.form.authCode.length >= 6) {
        this.$emit('submit', this.form.authCode)
      }
    },
    handleDeleteValue () {
      this.codeInputError = ''
      this.form.authCode = this.form.authCode.substring(0, this.form.authCode.length - 1)
    },
    // 重新发送验证码
    async handleResendCode () {
      await this.createCountdown()

      // 重新发送成功
      Toast.succeed(this.$t('resendSucc'))
    }
  }
}
</script>

<style lang="scss">
.register-title {
  font-size: 48px;
  margin-bottom: 24px;
}

.register-sub-title {
  margin-bottom: 40px;
  font-size: 32px;
  color: #7f7f7f;
}

.re-send-button {
  display: block;
  margin-top: 34px;
}

.error-view {
  margin-top: 88px;
  text-align: center;
  color: #fa5151;
}

.register-verification {
  padding: 50px 20px;
  border-radius: 0.32rem;
  box-shadow: 0 0.08rem 0.32rem 0 rgb(138 149 158 / 20%);
}

.opt-code {
  .code-item {
    width: 70px !important;
    height: 70px !important;
  }
}
</style>
